module.exports = __webpack_public_path__ + "static/img/rank_25.f7e77f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_25.png
// module id = 3Q5G
// module chunks = 1